var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "d-item" },
    [
      _c("p", [_vm._v(_vm._s(_vm.file.fileName))]),
      _c("Progress", {
        attrs: {
          percent: _vm.percent,
          status: _vm.file.status,
          "hide-info": ""
        }
      }),
      _c(
        "a",
        {
          staticStyle: { color: "red" },
          on: {
            click: function($event) {
              return _vm.file.retryFn()
            }
          }
        },
        [
          _vm.file.status === "wrong"
            ? _c("Icon", { attrs: { type: "md-refresh" } })
            : _vm._e()
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }